"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImagePreview = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var Icon_1 = require("../Icon");
var icons_1 = require("../../icons");
var styles_1 = __importDefault(require("./styles"));
var IconButton_1 = require("../IconButton");
exports.ImagePreview = react_1.default.memo(function (_a) {
    var src = _a.src, _b = _a.showDeleteIcon, showDeleteIcon = _b === void 0 ? false : _b, _c = _a.height, height = _c === void 0 ? 'auto' : _c, _d = _a.width, width = _d === void 0 ? 100 : _d, _e = _a.handler, handler = _e === void 0 ? function () { } : _e;
    var classes = (0, styles_1.default)({ height: height, width: width });
    return ((0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ className: classes.root }, { children: [showDeleteIcon && ((0, jsx_runtime_1.jsx)(IconButton_1.IconButton, { iconWidth: 16, iconHeight: 16, icon: (0, jsx_runtime_1.jsx)(Icon_1.Icon, __assign({ size: "small" }, { children: (0, jsx_runtime_1.jsx)(icons_1.Cancel, {}) })), id: "close-cancel-button", className: classes.icon, onClick: function () { return handler(); } })), (0, jsx_runtime_1.jsx)("img", { src: src, alt: "", className: classes.image, role: "img" })] })));
});
